import React from "react";
import Link from "next/link";
interface Props {
  className?: string;
}

const ProBadgeSvg: React.FC<Props> = ({ className }) => {
  return (
    <Link href="/comprar/membresia">
      <svg
        viewBox="0 0 37 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <path
          d="M11.238 4.517a4.62 4.62 0 01-.81 1.89c-.42.588-1.002 1.062-1.746 1.422-.732.36-1.614.54-2.646.54H3.93l-.846 4.824H.546L2.778.629h4.626c1.284 0 2.256.288 2.916.864.66.564.99 1.32.99 2.268 0 .276-.024.528-.072.756zm-4.95 1.872c.684 0 1.224-.168 1.62-.504.396-.336.648-.792.756-1.368a2.3 2.3 0 00.036-.468c0-.948-.588-1.422-1.764-1.422h-1.98L4.29 6.389h1.998zM18.445.629c1.284 0 2.256.294 2.916.882.66.576.99 1.332.99 2.268 0 .228-.018.462-.054.702-.144.816-.516 1.56-1.116 2.232-.588.66-1.38 1.122-2.376 1.386l2.106 5.094h-2.934l-1.872-4.896H14.9l-.864 4.896h-2.538L13.73.629h4.716zm1.26 3.906c.024-.216.036-.36.036-.432 0-.456-.144-.81-.432-1.062-.288-.252-.726-.378-1.314-.378H15.89l-.666 3.762h2.106c.672 0 1.206-.168 1.602-.504.408-.336.666-.798.774-1.386zM28.914 13.319c-1.056 0-1.992-.222-2.808-.666a4.84 4.84 0 01-1.872-1.872c-.444-.804-.666-1.722-.666-2.754 0-1.44.318-2.736.954-3.888a7.024 7.024 0 012.664-2.7c1.14-.66 2.418-.99 3.834-.99 1.068 0 2.004.222 2.808.666a4.655 4.655 0 011.89 1.872c.444.792.666 1.698.666 2.718 0 1.464-.318 2.772-.954 3.924a6.987 6.987 0 01-2.664 2.718c-1.14.648-2.424.972-3.852.972zm.36-2.322c.9 0 1.692-.228 2.376-.684a4.49 4.49 0 001.602-1.836c.384-.78.576-1.626.576-2.538 0-.984-.276-1.758-.828-2.322-.552-.564-1.326-.846-2.322-.846-.888 0-1.68.228-2.376.684A4.67 4.67 0 0026.7 5.29a5.703 5.703 0 00-.558 2.52c0 .984.27 1.764.81 2.34.552.564 1.326.846 2.322.846z"
          fill="#F65435"
        />
      </svg>
    </Link>
  );
};

export default ProBadgeSvg;
